import { component } from 'picoapp'
import Flickity from 'flickity'

class FeaturedReviews {
  constructor(node, ctx) {
    // bindings
    this.updateCarousel = this.updateCarousel.bind(this)
    this.onClickPaginationDot = this.onClickPaginationDot.bind(this)
    this.buildPaginationDots = this.buildPaginationDots.bind(this)

    // selectors
    this._node = node
    this._pagination_dots = this._node.getElementsByClassName('carousel-pagination-dots')[0]
    this._reviews_carousel = new Flickity(this._node.getElementsByClassName('flickity-reviews-carousel')[0], {
      pageDots: false,
      prevNextButtons: false,
      wrapAround: true,
      dragThreshold: 5
    })

    this._reviews_carousel.viewport.style.touchAction = "pan-y pinch-zoom"

    // privates
    this._dots = []
    this._number_of_slides = this._reviews_carousel.slides.length
    this._prev_number_of_slides = -1

    // events
    this._reviews_carousel.on('select', this.updateCarousel)

    Flickity.prototype._createResizeClass = function() {
      this.element.classList.add('flickity-resize');
    };

    Flickity.createMethods.push('_createResizeClass');

    let resize = Flickity.prototype.resize;
    Flickity.prototype.resize = function() {
      this.element.classList.remove('flickity-resize');
      resize.call( this );
      this.element.classList.add('flickity-resize');
    };

    this._reviews_carousel.resize();

    // set it
    this.buildPaginationDots()
    this.updateCarousel()

    // unmount
    return this.unmount.bind(this)
  }

  //
  // Build. Pagination Dots.
  //
  buildPaginationDots() {
    if (this._number_of_slides === this._prev_number_of_slides || this._number_of_slides <= 1) {
      return false
    }

    this._prev_number_of_slides = this._number_of_slides

    // remove event listeners if we have dots already...
    if (this._dots.length > 0) {
      this._dots.forEach((dot) => dot.removeEventListener('click', this.onClickPaginationDot, false))
    }

    let dots_html = ''
    for (var i = 0; i < this._number_of_slides; i++) {
      dots_html += '<li class="dot"></li>'
    }
    this._pagination_dots.innerHTML = dots_html

    // privates
    this._dots = Array.from(this._node.getElementsByClassName('dot'))

    // events
    this._dots.forEach((dot) => {
      dot.addEventListener('click', this.onClickPaginationDot, false)
    })
  }

  //
  // Update. Carousel.
  //
  updateCarousel() {
    let slide_index = this._reviews_carousel.selectedIndex,
        total_slides = this._reviews_carousel.slides.length

    this._number_of_slides = total_slides

    this._dots.forEach((dot, index) => {
      dot.classList.remove('selected')
      if (index === slide_index) {
        dot.classList.add('selected')
      }
    })

    this.buildPaginationDots()
  }

  //
  // Click. Pagination Dot.
  //
  onClickPaginationDot(e) {
    let el = e.currentTarget

    if (el.classList.contains('selected') === true) {
      return false
    }

    this._reviews_carousel.select(this._dots.indexOf(el))
  }

  //
  // Unmount.
  //
  unmount() {
    // events
    this._dots.forEach((dot) => dot.removeEventListener('click', this.onClickPaginationDot, false))
  }
}

export default component((node, ctx) => new FeaturedReviews(node, ctx))
